import { render, staticRenderFns } from "./SegmentNewForm.vue?vue&type=template&id=321a48cb"
import script from "./SegmentNewForm.vue?vue&type=script&lang=js"
export * from "./SegmentNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports